/**
 * @param {string[]} row
 * @returns {string}
 */
export const getRowID = (row) => {
  const asn = row[0];
  const prefix = row[1];
  return `${asn}-${prefix}`;
};
